import { Inbox } from "lucide-react";

export default function EmptyState({ icon: Icon = Inbox, title, hint, action, testId, className = "" }) {
  return (
    <div className={`panel relative overflow-hidden p-10 text-center fade-up ${className}`} data-testid={testId}>
      <div className="pointer-events-none absolute -top-16 left-1/2 h-40 w-72 -translate-x-1/2 rounded-full bg-primary/10 blur-3xl" />
      <div className="relative mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-primary/10 to-cyan-500/10 text-primary ring-1 ring-primary/15 animate-floaty">
        <Icon className="h-6 w-6" />
      </div>
      <div className="relative mt-4 font-display text-lg font-bold tracking-tight">{title}</div>
      {hint && <div className="relative mt-1 text-sm text-muted-foreground max-w-sm mx-auto">{hint}</div>}
      {action && <div className="relative mt-5 flex justify-center">{action}</div>}
    </div>
  );
}
